import { OpiApi } from "../../configs/appRoute";
import { AxiosAuth } from "../../core/Axios/AxiosInstance";
import type { VRIAppDispatch, VRIAppStateType } from "../../core/Redux/ReduxStore";
import { ActionInterpreterScript } from "../../core/Redux/Slices/sliceInterpreterScript";


export const requestInterpreterScript = (callerId?: string) => async (
  dispatch: VRIAppDispatch,
  getState: () => VRIAppStateType,
): Promise<void> => {
  if (!callerId?.trim()) return;
  const current = getState().interpreterScript.byCaller[callerId];
  if (current?.isLoading || current?.isLoaded || current?.error) return;

  dispatch(ActionInterpreterScript.FetchStart(callerId));
  try {
    const res = await AxiosAuth.get(OpiApi.CustomInput.GetInterpreterScript(callerId));
    const result = res?.data?.data;
    if (res.status !== 200 || res.data?.isSuccess !== true ||
        typeof result?.isEnabled !== "boolean" ||
        (result.isEnabled && typeof result.script !== "string")) {
      throw new Error("Failed to load interpreter script.");
    }
    dispatch(ActionInterpreterScript.FetchSuccess({
      callerId,
      isEnabled: result.isEnabled,
      script: result.isEnabled ? result.script : "",
    }));
  } catch (error: any) {
    dispatch(ActionInterpreterScript.FetchFailure({
      callerId,
      error: error?.message || "Failed to load interpreter script.",
    }));
  }
};
